import IcMenuDots from './IcMenuDots'

export default IcMenuDots
